import React from 'react';
import './Construccion.css';

function Construccion() {
  return (
    <div className="construccion-container">
      <div className="container">
        
        {/* Header con logo e imagen */}
        <div className="header">
          <h1 className="title">
            <span className="title-eco">ECO</span>
            <span className="title-lam">LAM</span>
          </h1>
          <p className="tagline">Empresa dedicada al Secado y Elaboracion de Maderas, Muebles, Embalajes, Pallets, Bins, Certificacion Nimf. N°15</p>
        </div>

        {/* Contenido principal */}
        <div className="main-content">
          
          {/* Icono de construcción con temática de madera */}

          
          <h2 className="subtitle">
            Sitio en Construcción
          </h2>
          
          <p className="description">
            Estamos trabajando en nuestro nuevo sitio web para mostrar 
            la calidad y artesanía de nuestros muebles y trabajos en madera.
          </p>
          
          <div className="separator">
            <div className="separator-line"></div>
            <div className="separator-circle"></div>
            <div className="separator-line"></div>
          </div>

          {/* Información de contacto */}
          <div className="contact-section">
            <h3 className="contact-title">Contáctenos</h3>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <svg className="contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92V19.92C22.001 20.198 21.944 20.473 21.833 20.728C21.721 20.983 21.558 21.212 21.353 21.4C21.148 21.588 20.906 21.731 20.644 21.821C20.381 21.91 20.103 21.944 19.827 21.92C16.743 21.586 13.787 20.393 11.24 18.44C8.922 16.68 7.069 14.42 5.83 11.85C4.677 9.455 4.08 6.816 4.08 4.14C4.08 3.418 4.168 2.699 4.34 2C4.446 1.402 4.761 1.002 5.34 1C7.34 1 9.34 1 11.34 1C11.98 1 12.48 1.33 12.71 1.94C13 2.68 13.33 3.41 13.65 4.14C13.82 4.541 13.83 5.019 13.68 5.44C13.54 5.861 13.25 6.2 12.87 6.39L10.65 7.54C12.037 10.053 14.004 12.153 16.36 13.65L17.56 11.6C17.85 11.07 18.33 10.67 18.95 10.5C19.57 10.33 20.09 10.41 20.61 10.68C21.342 11.06 22.077 11.43 22.81 11.81C23.37 12.1 23.66 12.62 23.66 13.27C23.66 14.276 23.66 15.283 23.66 16.29C23.66 16.569 23.584 16.843 23.44 17.085C23.296 17.327 23.09 17.527 22.843 17.665C22.596 17.803 22.317 17.874 22.034 17.87C21.75 17.867 21.473 17.789 21.23 17.645C20.987 17.5 20.786 17.294 20.647 17.047C20.507 16.8 20.435 16.52 20.437 16.236C20.44 15.953 20.517 15.674 20.66 15.43C20.804 15.186 21.01 14.985 21.257 14.846C21.503 14.707 21.782 14.635 22.066 14.637C22.349 14.64 22.627 14.717 22.87 14.861C22.957 14.917 22.993 15.011 22.98 15.11C22.967 15.209 22.907 15.29 22.82 15.33C22.487 15.49 22.16 15.66 21.82 15.81C21.65 15.88 21.54 16.05 21.54 16.24C21.54 16.43 21.65 16.6 21.82 16.67C22.16 16.82 22.487 16.99 22.82 17.15C22.907 17.19 22.967 17.271 22.98 17.37C22.993 17.469 22.957 17.563 22.87 17.619C22.627 17.763 22.349 17.84 22.066 17.843C21.782 17.845 21.503 17.773 21.257 17.634C21.01 17.495 20.804 17.294 20.66 17.05C20.517 16.806 20.44 16.527 20.437 16.244C20.435 15.96 20.507 15.68 20.647 15.433C20.786 15.186 20.987 14.98 21.23 14.835C21.473 14.691 21.75 14.613 22.034 14.61C22.317 14.606 22.596 14.677 22.843 14.815C23.09 14.953 23.296 15.153 23.44 15.395C23.584 15.637 23.661 15.911 23.66 16.19V16.92Z" fill="#ffffffff"/>
                  </svg>
                </div>
                <div className="contact-text">
                  <span className="contact-label">Teléfono y WhatsApp</span>
                  <a href="https://wa.me/56934019249?text=Hola,%20quiero%20cotizar" target="_blank" rel="noopener noreferrer" className="contact-value">
                    +569 3401 9249
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <svg className="contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#fafafaff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 6L12 13L2 6" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="contact-text">
                  <span className="contact-label">Email</span>
                  <a href="mailto:ventas.myecolam@gmail.com" className="contact-value">
                    ventas.myecolam@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon-wrapper">
                  <svg className="contact-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="contact-text">
                  <span className="contact-label">Dirección</span>
                  <a href="https://maps.app.goo.gl/EmfTWLrci9Pb1KgY7" target="_blank" rel="noopener noreferrer" className="contact-value">
                    Ruta 5 Sur KM 110 #SN Comuna Rengo.
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Mensaje final */}
          <div className="final-message">
            <p>¡Volveremos pronto con una experiencia mejorada!</p>
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <p className="footer-text">
            © {new Date().getFullYear()} ECOLAM. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Construccion;